import { Grid } from '@mui/material'
import { DiscountContract, DiscountType } from 'models'
import { useCallback, useMemo } from 'react'
import { DiscountContractWithItemId } from 'store/models/sellModels'
import { ItemDiscountTag } from './DiscountTag'
import { isUndefined } from 'lodash-es'
import { isFreeDiscount } from 'components/Sell/DiscountBogoDialog/hook/buyXgetYProcess'
import usePosNameFormat from 'components/Sell/hook/usePosNameFormat'
import { useTranslation } from 'react-i18next'
import Decimal from 'decimal.js'
import { calculateDiscounts } from 'views/Sale/utils/orderCalculation/discountCalculation'

interface CartDiscountProps {
    totalLinePrice: number
    discounts: DiscountContract[]
    margin?: number
    noPaddingRight?: boolean
    id?: string
    itemAmount?: number

    setSelectDiscount?: (itemDiscount: DiscountContractWithItemId) => void
    selectDiscount: DiscountContractWithItemId | undefined

    onRemoveDiscount?: (discount: DiscountContractWithItemId) => void
    disableEditOrder?: boolean
}

function CartDiscount({
    totalLinePrice,
    discounts,
    margin = 3,
    noPaddingRight = false,
    id,
    itemAmount = 1,
    selectDiscount,
    setSelectDiscount,
    onRemoveDiscount,
    disableEditOrder,
}: CartDiscountProps) {
    const { getDiscountName } = usePosNameFormat()
    const { t } = useTranslation()
    const clickToSelectDiscount = useCallback(
        (_discount: DiscountContract) => {
            if (setSelectDiscount) setSelectDiscount({ ..._discount, id: id!! })
        },
        [setSelectDiscount, id],
    )

    const discountDisplay = useMemo(() => {
        return calculateDiscounts(
            new Decimal(totalLinePrice),
            discounts,
            itemAmount,
        )
    }, [discounts, itemAmount, totalLinePrice])
    return (
        <Grid item container direction="column">
            {discountDisplay.map((discount) => {
                return (
                    <ItemDiscountTag
                        disableEditOrder={disableEditOrder}
                        name={getDiscountName(discount.discount)}
                        discountAmount={discount.amount?.toNumber() ?? 0}
                        key={`${id}-${discount.discount.discountID}`}
                        isSelected={
                            selectDiscount?.discountID ===
                                discount.discount.discountID &&
                            selectDiscount?.id!! === id
                        }
                        showDiscountValue={
                            !(
                                discount.discount.type ===
                                    DiscountType.FutureDiscount ||
                                isFreeDiscount(discount.discount)
                            )
                        }
                        onClick={
                            setSelectDiscount
                                ? () => clickToSelectDiscount(discount.discount)
                                : undefined
                        }
                        margin={margin}
                        noPaddingRight={noPaddingRight}
                        onRemove={
                            onRemoveDiscount
                                ? () =>
                                      onRemoveDiscount({
                                          ...discount.discount,
                                          id: id!!,
                                      })
                                : undefined
                        }
                        note={
                            isUndefined(setSelectDiscount) &&
                            !discount.discount.isCombinable
                                ? t('discounts.label.non_combinable')
                                : undefined
                        }
                    />
                )
            })}
        </Grid>
    )
}

export default CartDiscount
